import axios from "axios";

export const getBalanceSheet = ({
  uen,
  model,
  parents,
  language,
  filterTypePeriod,
  year
}) => {
  const requestUrl = `/data/balance`;

  let params = {
    uen: uen,
    model: model,
    parents: parents,
    language: language,
    filterTypePeriod: filterTypePeriod,
    year: year
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/balance-sheet.js